export const StrengthText = {
  0: "Very weak",
  1: "Weak",
  2: "Fair",
  3: "Good",
  4: "Strong",
  5: "Very Weak",
};

export const StrengthColor = {
  0: "#828282",
  1: "#EA1111",
  2: "#FFAD00",
  3: "#9bc158",
  4: "#00b500",
  5: "#828282",
};
